import { Credentials, User } from "@/types";
import { requests, responseBody } from "../http/axios";

export const AuthService = {
    signUp: async (credentials: Credentials): Promise<any> => requests.post('auth/signup', credentials),
    login: async (credentials: Credentials): Promise<any> => requests.post('auth/login', credentials),
    logout: async (): Promise<void> => requests.delete('auth/logout'),
    sendResetCode: async (email: string): Promise<any> => requests.post('auth/send_reset_code', { email }),
    resetPassword: async ({ email, password, code }: { email: string, password: string, code: string }): Promise<any> => requests.post('auth/reset_password', { email, password, verificationCode: code }),
    me: async (): Promise<User> => requests.get('user').then(responseBody),
};

